// extracted by mini-css-extract-plugin
export default {"CardList":"index__CardList--RWsh5","cardList":"index__CardList--RWsh5","CardListNoTitle":"index__CardListNoTitle--YJuvj","cardListNoTitle":"index__CardListNoTitle--YJuvj"};